import React from 'react';
import { Modal, Loading } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import useDeleteList from 'Hooks/query-hooks/list/useDeleteList';
import { EventNames, EventTypes, trackEvent } from '@brighterion/insights';
import styles from './DeleteListModal.css';

type Props = {
    onClose: () => void;
    listId?: number;
    listName?: string;
};

const DeleteListModal = ({ onClose, listId, listName }: Props) => {
    const { t } = useTranslation();
    const { isLoading, mutate } = useDeleteList({
        mutationOptions: {
            onSuccess: () => {
                onClose();
            },
            onError: () => {
                onClose();
            }
        },
        listName
    });

    const onDelete = () => {
        if (listId) {
            mutate(listId);
            trackEvent({
                eventType: EventTypes.track,
                eventName: EventNames.click,
                payload: {
                    clickIdentifier: 'Lists - Delete List',
                    text: 'Delete List'
                }
            });
        }
    };

    return (
        <Modal
            dataTestId='delete-entry-modal'
            isOpen={listId !== undefined}
            closeModal={onClose}
            status='warning'
            containerClass={styles.modalContainer}
        >
            <Modal.Title
                id='delete-entry-title'
                title={t('deleteList.deleteList')}
                statusIcon='warning'
                onClose={onClose}
            />
            <div className={styles.deleteWarningContent}>
                <div className={styles.sectionOne}>{t('deleteList.areYouSure')}</div>
                <div>{t('deleteList.cannotBeUndone')}</div>
            </div>
            <Modal.Footer
                id='delete-entry-footer'
                onAction={onDelete}
                disableOnCancel={isLoading}
                disableOnAction={isLoading}
                onActionText={isLoading ? <Loading size='sm' fillName='white' /> : t('Delete List')}
                onClose={onClose}
                onCloseText={t('Cancel')}
            />
        </Modal>
    );
};

export default DeleteListModal;
